import {TileEntrySubmission} from "../../models/app/Tile";

export const MOCK_PRACTICE_SESSIONS: TileEntrySubmission[] = [
  {
    "userID":"23744275",
    "grade":"10.0",
    "entry_id": 30
  },
  {
    "userID":"20936679",
    "grade":"9.3",
    "entry_id": 30
  },
  {
    "userID":"45844627",
    "grade":"8.9",
    "entry_id": 30
  },
  {
    "userID":"95372011",
    "grade":"8.6",
    "entry_id": 30
  },
  {
    "userID":"22976781",
    "grade":"8.6",
    "entry_id": 30
  },
  {
    "userID":"77161172",
    "grade":"8.6",
    "entry_id": 30
  },
  {
    "userID":"29376337",
    "grade":"8.2",
    "entry_id": 30
  },
  {
    "userID":"74114284",
    "grade":"8.2",
    "entry_id": 30
  },
  {
    "userID":"18298956",
    "grade":"8.2",
    "entry_id": 30
  },
  {

    "userID":"41898388",
    "grade":"8.2",
    "entry_id": 30
  },
  {

    "userID":"21276717",
    "grade":"8.2",
    "entry_id": 30
  },
  {

    "userID":"42345728",
    "grade":"8.2",
    "entry_id": 30
  },
  {

    "userID":"32324131",
    "grade":"7.9",
    "entry_id": 30
  },
  {

    "userID":"23400528",
    "grade":"7.9",
    "entry_id": 30
  },
  {

    "userID":"59540503",
    "grade":"7.9",
    "entry_id": 30
  },
  {

    "userID":"46666218",
    "grade":"7.9",
    "entry_id": 30
  },
  {

    "userID":"28624178",
    "grade":"7.9",
    "entry_id": 30
  },
  {

    "userID":"41393783",
    "grade":"7.5",
    "entry_id": 30
  },
  {

    "userID":"43219917",
    "grade":"7.5",
    "entry_id": 30
  },
  {

    "userID":"54264654",
    "grade":"7.5",
    "entry_id": 30
  },
  {

    "userID":"45476233",
    "grade":"7.5",
    "entry_id": 30
  },
  {

    "userID":"55249485",
    "grade":"7.5",
    "entry_id": 30
  },
  {

    "userID":"97222205",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"35683215",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"43754947",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"27034712",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"76262947",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"55571292",
    "grade":"7.1",
    "entry_id": 30
  },
  {

    "userID":"50326251",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"90434281",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"66889858",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"95366984",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"27817769",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"70805720",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"16967126",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"24585559",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"48905367",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"48470625",
    "grade":"6.8",
    "entry_id": 30
  },
  {

    "userID":"52682411",
    "grade":"6.4",
    "entry_id": 30
  },
  {

    "userID":"38152009",
    "grade":"6.4",
    "entry_id": 30
  },
  {

    "userID":"41803722",
    "grade":"6.4",
    "entry_id": 30
  },
  {

    "userID":"53036575",
    "grade":"6.1",
    "entry_id": 30
  },
  {

    "userID":"96600883",
    "grade":"6.1",
    "entry_id": 30
  },
  {

    "userID":"81005245",
    "grade":"6.1",
    "entry_id": 30
  },
  {

    "userID":"74886921",
    "grade":"5.7",
    "entry_id": 30
  },
  {

    "userID":"81888190",
    "grade":"5.7",
    "entry_id": 30
  },
  {

    "userID":"86899376",
    "grade":"5.7",
    "entry_id": 30
  },
  {

    "userID":"46647543",
    "grade":"5.4",
    "entry_id": 30
  },
  {

    "userID":"31665008",
    "grade":"5.4",
    "entry_id": 30
  },
  {

    "userID":"41149744",
    "grade":"4.6",
    "entry_id": 30
  },
  {

    "userID":"28332183",
    "grade":"4.3",
    "entry_id": 30
  },
  {

    "userID":"35251913",
    "grade":"2.1",
    "entry_id": 30
  },
  {

    "userID":"23744275",
    "grade":"8.5",
    "entry_id": 31
  },
  {

    "userID":"23400528",
    "grade":"8.5",
    "entry_id": 31
  },
  {

    "userID":"50326251",
    "grade":"8.5",
    "entry_id": 31
  },
  {

    "userID":"96600883",
    "grade":"8.5",
    "entry_id": 31
  },
  {

    "userID":"95366984",
    "grade":"8.1",
    "entry_id": 31
  },
  {

    "userID":"76262947",
    "grade":"8.1",
    "entry_id": 31
  },
  {

    "userID":"45476233",
    "grade":"8.1",
    "entry_id": 31
  },
  {

    "userID":"46666218",
    "grade":"8.1",
    "entry_id": 31
  },
  {

    "userID":"45844627",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"95372011",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"41149744",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"41898388",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"53036575",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"27034712",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"24585559",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"48905367",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"55571292",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"32324131",
    "grade":"7.8",
    "entry_id": 31
  },
  {

    "userID":"20380320",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"86899376",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"21276717",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"70805720",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"48470625",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"55249485",
    "grade":"7.4",
    "entry_id": 31
  },
  {

    "userID":"74114284",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"43219917",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"38152009",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"18298956",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"35683215",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"54264654",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"20936679",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"42345728",
    "grade":"7.0",
    "entry_id": 31
  },
  {

    "userID":"43754947",
    "grade":"6.8",
    "entry_id": 31
  },
  {

    "userID":"66889858",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"35251913",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"22976781",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"31665008",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"59540503",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"81005245",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"28624178",
    "grade":"6.7",
    "entry_id": 31
  },
  {

    "userID":"41803722",
    "grade":"6.5",
    "entry_id": 31
  },
  {

    "userID":"96955357",
    "grade":"6.3",
    "entry_id": 31
  },
  {

    "userID":"74886921",
    "grade":"6.3",
    "entry_id": 31
  },
  {

    "userID":"28332183",
    "grade":"6.3",
    "entry_id": 31
  },
  {

    "userID":"52682411",
    "grade":"5.9",
    "entry_id": 31
  },
  {

    "userID":"41393783",
    "grade":"5.9",
    "entry_id": 31
  },
  {

    "userID":"97222205",
    "grade":"5.9",
    "entry_id": 31
  },
  {

    "userID":"27817769",
    "grade":"5.9",
    "entry_id": 31
  },
  {

    "userID":"16967126",
    "grade":"5.9",
    "entry_id": 31
  },
  {

    "userID":"90434281",
    "grade":"5.6",
    "entry_id": 31
  },
  {

    "userID":"81888190",
    "grade":"5.6",
    "entry_id": 31
  },
  {

    "userID":"77161172",
    "grade":"5.6",
    "entry_id": 31
  },
  {

    "userID":"29376337",
    "grade":"4.8",
    "entry_id": 31
  },
  {

    "userID":"46647543",
    "grade":"3.3",
    "entry_id": 31
  },
  {

    "userID":"41149744",
    "grade":"9.8",
    "entry_id": 32
  },
  {

    "userID":"41393783",
    "grade":"9.1",
    "entry_id": 32
  },
  {

    "userID":"41898388",
    "grade":"9.1",
    "entry_id": 32
  },
  {

    "userID":"59540503",
    "grade":"8.4",
    "entry_id": 32
  },
  {

    "userID":"54264654",
    "grade":"8.4",
    "entry_id": 32
  },
  {

    "userID":"42345728",
    "grade":"8.4",
    "entry_id": 32
  },
  {

    "userID":"50326251",
    "grade":"8.2",
    "entry_id": 32
  },
  {

    "userID":"23744275",
    "grade":"7.9",
    "entry_id": 32
  },
  {

    "userID":"45476233",
    "grade":"7.9",
    "entry_id": 32
  },
  {

    "userID":"41803722",
    "grade":"7.7",
    "entry_id": 32
  },
  {

    "userID":"48905367",
    "grade":"7.7",
    "entry_id": 32
  },
  {

    "userID":"27034712",
    "grade":"7.7",
    "entry_id": 32
  },
  {

    "userID":"18298956",
    "grade":"7.3",
    "entry_id": 32
  },
  {

    "userID":"95372011",
    "grade":"7.3",
    "entry_id": 32
  },
  {

    "userID":"45844627",
    "grade":"7.1",
    "entry_id": 32
  },
  {

    "userID":"16967126",
    "grade":"6.8",
    "entry_id": 32
  },
  {

    "userID":"23400528",
    "grade":"6.8",
    "entry_id": 32
  },
  {

    "userID":"52682411",
    "grade":"6.6",
    "entry_id": 32
  },
  {

    "userID":"20380320",
    "grade":"6.6",
    "entry_id": 32
  },
  {

    "userID":"53036575",
    "grade":"6.4",
    "entry_id": 32
  },
  {

    "userID":"38152009",
    "grade":"6.4",
    "entry_id": 32
  },
  {

    "userID":"70805720",
    "grade":"6.3",
    "entry_id": 32
  },
  {

    "userID":"46666218",
    "grade":"6.3",
    "entry_id": 32
  },
  {

    "userID":"46647543",
    "grade":"6.3",
    "entry_id": 32
  },
  {

    "userID":"81888190",
    "grade":"6.3",
    "entry_id": 32
  },
  {

    "userID":"20936679",
    "grade":"6.1",
    "entry_id": 32
  },
  {

    "userID":"22976781",
    "grade":"5.9",
    "entry_id": 32
  },
  {

    "userID":"86899376",
    "grade":"5.9",
    "entry_id": 32
  },
  {

    "userID":"96955357",
    "grade":"5.9",
    "entry_id": 32
  },
  {

    "userID":"66889858",
    "grade":"5.5",
    "entry_id": 32
  },
  {

    "userID":"24585559",
    "grade":"5.5",
    "entry_id": 32
  },
  {

    "userID":"74114284",
    "grade":"5.4",
    "entry_id": 32
  },
  {

    "userID":"35251913",
    "grade":"5.4",
    "entry_id": 32
  },
  {

    "userID":"29376337",
    "grade":"5.4",
    "entry_id": 32
  },
  {

    "userID":"76262947",
    "grade":"5.4",
    "entry_id": 32
  },
  {

    "userID":"55571292",
    "grade":"5.2",
    "entry_id": 32
  },
  {

    "userID":"48470625",
    "grade":"5.2",
    "entry_id": 32
  },
  {

    "userID":"43754947",
    "grade":"5.0",
    "entry_id": 32
  },
  {

    "userID":"97222205",
    "grade":"4.6",
    "entry_id": 32
  },
  {

    "userID":"96600883",
    "grade":"4.6",
    "entry_id": 32
  },
  {

    "userID":"81005245",
    "grade":"4.6",
    "entry_id": 32
  },
  {

    "userID":"31665008",
    "grade":"4.6",
    "entry_id": 32
  },
  {

    "userID":"28624178",
    "grade":"4.5",
    "entry_id": 32
  },
  {

    "userID":"28332183",
    "grade":"4.5",
    "entry_id": 32
  },
  {

    "userID":"43219917",
    "grade":"4.3",
    "entry_id": 32
  },
  {

    "userID":"55249485",
    "grade":"4.1",
    "entry_id": 32
  },
  {

    "userID":"90434281",
    "grade":"3.8",
    "entry_id": 32
  },
  {

    "userID":"95366984",
    "grade":"3.6",
    "entry_id": 32
  },
  {

    "userID":"35683215",
    "grade":"3.4",
    "entry_id": 32
  },
  {

    "userID":"27817769",
    "grade":"3.4",
    "entry_id": 32
  },
  {

    "userID":"77161172",
    "grade":"2.5",
    "entry_id": 32
  },
  {

    "userID":"21276717",
    "grade":"1.8",
    "entry_id": 32
  },
  {

    "userID":"23744275",
    "grade":"9.3",
    "entry_id": 33
  },
  {

    "userID":"95366984",
    "grade":"9.3",
    "entry_id": 33
  },
  {

    "userID":"48905367",
    "grade":"9.0",
    "entry_id": 33
  },
  {

    "userID":"59540503",
    "grade":"8.3",
    "entry_id": 33
  },
  {

    "userID":"81005245",
    "grade":"8.3",
    "entry_id": 33
  },
  {

    "userID":"45844627",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"74114284",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"50326251",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"35683215",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"27817769",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"41898388",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"21276717",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"53036575",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"55249485",
    "grade":"8.0",
    "entry_id": 33
  },
  {

    "userID":"29376337",
    "grade":"7.7",
    "entry_id": 33
  },
  {

    "userID":"41393783",
    "grade":"7.7",
    "entry_id": 33
  },
  {

    "userID":"70805720",
    "grade":"7.7",
    "entry_id": 33
  },
  {

    "userID":"43754947",
    "grade":"7.7",
    "entry_id": 33
  },
  {

    "userID":"23400528",
    "grade":"7.3",
    "entry_id": 33
  },
  {

    "userID":"54264654",
    "grade":"7.3",
    "entry_id": 33
  },
  {

    "userID":"96600883",
    "grade":"7.3",
    "entry_id": 33
  },
  {

    "userID":"46666218",
    "grade":"7.3",
    "entry_id": 33
  },
  {

    "userID":"74886921",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"20380320",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"18298956",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"41149744",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"31665008",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"16967126",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"77161172",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"55571292",
    "grade":"7.0",
    "entry_id": 33
  },
  {

    "userID":"20936679",
    "grade":"6.7",
    "entry_id": 33
  },
  {

    "userID":"27034712",
    "grade":"6.7",
    "entry_id": 33
  },
  {

    "userID":"24585559",
    "grade":"6.7",
    "entry_id": 33
  },
  {

    "userID":"48470625",
    "grade":"6.7",
    "entry_id": 33
  },
  {

    "userID":"42345728",
    "grade":"6.7",
    "entry_id": 33
  },
  {

    "userID":"66889858",
    "grade":"6.3",
    "entry_id": 33
  },
  {

    "userID":"32324131",
    "grade":"6.3",
    "entry_id": 33
  },
  {

    "userID":"90434281",
    "grade":"6.0",
    "entry_id": 33
  },
  {

    "userID":"95372011",
    "grade":"6.0",
    "entry_id": 33
  },
  {

    "userID":"86899376",
    "grade":"6.0",
    "entry_id": 33
  },
  {

    "userID":"41803722",
    "grade":"6.0",
    "entry_id": 33
  },
  {

    "userID":"28624178",
    "grade":"6.0",
    "entry_id": 33
  },
  {

    "userID":"52682411",
    "grade":"5.7",
    "entry_id": 33
  },
  {

    "userID":"35251913",
    "grade":"5.7",
    "entry_id": 33
  },
  {

    "userID":"38152009",
    "grade":"5.7",
    "entry_id": 33
  },
  {

    "userID":"22976781",
    "grade":"5.7",
    "entry_id": 33
  },
  {

    "userID":"76262947",
    "grade":"5.7",
    "entry_id": 33
  },
  {

    "userID":"28332183",
    "grade":"5.3",
    "entry_id": 33
  },
  {

    "userID":"46647543",
    "grade":"5.3",
    "entry_id": 33
  },
  {

    "userID":"45476233",
    "grade":"5.0",
    "entry_id": 33
  },
  {

    "userID":"96955357",
    "grade":"4.0",
    "entry_id": 33
  },
  {

    "userID":"45844627",
    "grade":"8.5",
    "entry_id": 34
  },
  {

    "userID":"50326251",
    "grade":"8.0",
    "entry_id": 34
  },
  {

    "userID":"74114284",
    "grade":"7.5",
    "entry_id": 34
  },
  {

    "userID":"77161172",
    "grade":"6.7",
    "entry_id": 34
  },
  {

    "userID":"27817769",
    "grade":"6.7",
    "entry_id": 34
  },
  {

    "userID":"95372011",
    "grade":"6.7",
    "entry_id": 34
  },
  {

    "userID":"32324131",
    "grade":"6.5",
    "entry_id": 34
  },
  {

    "userID":"23744275",
    "grade":"6.5",
    "entry_id": 34
  },
  {

    "userID":"24585559",
    "grade":"6.2",
    "entry_id": 34
  },
  {

    "userID":"48905367",
    "grade":"6.2",
    "entry_id": 34
  },
  {

    "userID":"43754947",
    "grade":"6.0",
    "entry_id": 34
  },
  {

    "userID":"53036575",
    "grade":"6.0",
    "entry_id": 34
  },
  {

    "userID":"21276717",
    "grade":"5.7",
    "entry_id": 34
  },
  {

    "userID":"45476233",
    "grade":"5.5",
    "entry_id": 34
  },
  {

    "userID":"23400528",
    "grade":"5.5",
    "entry_id": 34
  },
  {

    "userID":"18298956",
    "grade":"5.5",
    "entry_id": 34
  },
  {

    "userID":"76262947",
    "grade":"5.5",
    "entry_id": 34
  },
  {

    "userID":"22976781",
    "grade":"5.0",
    "entry_id": 34
  },
  {

    "userID":"95366984",
    "grade":"5.0",
    "entry_id": 34
  },
  {

    "userID":"70805720",
    "grade":"5.0",
    "entry_id": 34
  },
  {

    "userID":"46666218",
    "grade":"5.0",
    "entry_id": 34
  },
  {

    "userID":"74886921",
    "grade":"4.7",
    "entry_id": 34
  },
  {

    "userID":"55571292",
    "grade":"4.7",
    "entry_id": 34
  },
  {

    "userID":"59540503",
    "grade":"4.2",
    "entry_id": 34
  },
  {

    "userID":"16967126",
    "grade":"4.2",
    "entry_id": 34
  },
  {

    "userID":"46647543",
    "grade":"4.2",
    "entry_id": 34
  },
  {

    "userID":"54264654",
    "grade":"4.0",
    "entry_id": 34
  },
  {

    "userID":"42345728",
    "grade":"4.0",
    "entry_id": 34
  },
  {

    "userID":"41393783",
    "grade":"4.0",
    "entry_id": 34
  },
  {

    "userID":"48470625",
    "grade":"4.0",
    "entry_id": 34
  },
  {

    "userID":"27034712",
    "grade":"4.0",
    "entry_id": 34
  },
  {

    "userID":"43219917",
    "grade":"3.7",
    "entry_id": 34
  },
  {

    "userID":"55249485",
    "grade":"3.7",
    "entry_id": 34
  },
  {

    "userID":"20936679",
    "grade":"3.7",
    "entry_id": 34
  },
  {

    "userID":"66889858",
    "grade":"3.5",
    "entry_id": 34
  },
  {

    "userID":"35251913",
    "grade":"3.5",
    "entry_id": 34
  },
  {

    "userID":"52682411",
    "grade":"3.5",
    "entry_id": 34
  },
  {

    "userID":"41898388",
    "grade":"3.5",
    "entry_id": 34
  },
  {

    "userID":"41803722",
    "grade":"3.2",
    "entry_id": 34
  },
  {

    "userID":"90434281",
    "grade":"3.0",
    "entry_id": 34
  },
  {

    "userID":"96955357",
    "grade":"2.7",
    "entry_id": 34
  },
  {

    "userID":"28624178",
    "grade":"2.5",
    "entry_id": 34
  },
  {

    "userID":"86899376",
    "grade":"2.5",
    "entry_id": 34
  },
  {

    "userID":"35683215",
    "grade":"2.2",
    "entry_id": 34
  },
  {

    "userID":"81005245",
    "grade":"2.0",
    "entry_id": 34
  },
  {

    "userID":"38152009",
    "grade":"2.0",
    "entry_id": 34
  },
  {

    "userID":"81888190",
    "grade":"1.5",
    "entry_id": 34
  },
  {

    "userID":"96600883",
    "grade":"1.0",
    "entry_id": 34
  },
  {

    "userID":"29376337",
    "grade":"1.0",
    "entry_id": 34
  },
  {

    "userID":"31665008",
    "grade":"1.0",
    "entry_id": 34
  },
  {

    "userID":"28332183",
    "grade":"1.0",
    "entry_id": 34
  },
  {

    "userID":"41149744",
    "grade":"1.0",
    "entry_id": 34
  },
  {

    "userID":"32324131",
    "grade":"7.8",
    "entry_id": 35
  },
  {

    "userID":"41393783",
    "grade":"6.7",
    "entry_id": 35
  },
  {

    "userID":"97222205",
    "grade":"6.7",
    "entry_id": 35
  },
  {

    "userID":"66889858",
    "grade":"6.7",
    "entry_id": 35
  },
  {

    "userID":"45476233",
    "grade":"6.7",
    "entry_id": 35
  },
  {

    "userID":"46666218",
    "grade":"6.7",
    "entry_id": 35
  },
  {

    "userID":"43219917",
    "grade":"5.6",
    "entry_id": 35
  },
  {

    "userID":"23744275",
    "grade":"5.6",
    "entry_id": 35
  },
  {

    "userID":"18298956",
    "grade":"5.6",
    "entry_id": 35
  },
  {

    "userID":"22976781",
    "grade":"5.6",
    "entry_id": 35
  },
  {

    "userID":"20936679",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"27034712",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"48905367",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"48470625",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"42345728",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"77161172",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"55249485",
    "grade":"5.6",
    "entry_id": 35
  },
  {
    "userID":"45844627",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"74114284",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"90434281",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"95366984",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"81888190",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"23400528",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"35251913",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"35683215",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"95372011",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"41149744",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"86899376",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"54264654",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"41898388",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"53036575",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"96600883",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"55571292",
    "grade":"4.4",
    "entry_id": 35
  },
  {
    "userID":"74886921",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"20380320",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"50326251",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"21276717",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"43754947",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"24585559",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"81005245",
    "grade":"3.3",
    "entry_id": 35
  },
  {
    "userID":"29376337",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"52682411",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"96955357",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"46647543",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"70805720",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"31665008",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"16967126",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"59540503",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"76262947",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"41803722",
    "grade":"2.2",
    "entry_id": 35
  },
  {
    "userID":"38152009",
    "grade":"1.1",
    "entry_id": 35
  },
  {
    "userID":"28332183",
    "grade":"1.0",
    "entry_id": 35
  },
  {
    "userID":"27817769",
    "grade":"1.0",
    "entry_id": 35
  },
  {
    "userID":"23744275",
    "grade":"7.5",
    "entry_id": 36
  },
  {
    "userID":"66889858",
    "grade":"7.5",
    "entry_id": 36
  },
  {
    "userID":"54264654",
    "grade":"7.0",
    "entry_id": 36
  },
  {
    "userID":"96600883",
    "grade":"7.0",
    "entry_id": 36
  },
  {
    "userID":"46666218",
    "grade":"7.0",
    "entry_id": 36
  },
  {
    "userID":"74114284",
    "grade":"6.5",
    "entry_id": 36
  },
  {
    "userID":"27034712",
    "grade":"6.5",
    "entry_id": 36
  },
  {
    "userID":"48905367",
    "grade":"6.5",
    "entry_id": 36
  },
  {
    "userID":"45476233",
    "grade":"6.5",
    "entry_id": 36
  },
  {
    "userID":"96955357",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"41393783",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"43219917",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"97222205",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"32324131",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"74886921",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"35251913",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"50326251",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"27817769",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"95372011",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"22976781",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"41898388",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"24585559",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"59540503",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"48470625",
    "grade":"6.0",
    "entry_id": 36
  },
  {
    "userID":"52682411",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"20380320",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"23400528",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"38152009",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"18298956",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"35683215",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"70805720",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"41803722",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"55249485",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"28624178",
    "grade":"5.5",
    "entry_id": 36
  },
  {
    "userID":"29376337",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"95366984",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"43754947",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"53036575",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"16967126",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"81005245",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"55571292",
    "grade":"5.0",
    "entry_id": 36
  },
  {
    "userID":"28332183",
    "grade":"4.5",
    "entry_id": 36
  },
  {
    "userID":"86899376",
    "grade":"4.5",
    "entry_id": 36
  },
  {
    "userID":"20936679",
    "grade":"4.5",
    "entry_id": 36
  },
  {
    "userID":"42345728",
    "grade":"4.5",
    "entry_id": 36
  },
  {
    "userID":"81888190",
    "grade":"4.0",
    "entry_id": 36
  },
  {
    "userID":"31665008",
    "grade":"4.0",
    "entry_id": 36
  },
  {
    "userID":"76262947",
    "grade":"3.5",
    "entry_id": 36
  },
  {
    "userID":"77161172",
    "grade":"3.5",
    "entry_id": 36
  },
  {
    "userID":"41149744",
    "grade":"3.0",
    "entry_id": 36
  },
  {
    "userID":"21276717",
    "grade":"3.0",
    "entry_id": 36
  },
  {
    "userID":"46647543",
    "grade":"2.5",
    "entry_id": 36
  }
];
